function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.67182 8.61419C1.67182 6.89076 2.23792 5.29875 3.19418 4.01407L6.30039 7.11696V8.67263C6.30039 10.489 7.64439 12.1875 9.45039 12.5999C10.0336 12.4667 10.5687 12.1994 11.0258 11.8373L13.9928 14.8012C12.707 15.7604 11.1125 16.3285 9.3861 16.3285C8.1981 16.3285 7.08725 16.0508 6.07668 15.5802L0.900391 17.0999L2.4201 11.9236C1.94953 10.913 1.67182 9.80219 1.67182 8.61419ZM8.49142 5.79843L4.97621 2.2851C6.22633 1.41211 7.74676 0.899902 9.3861 0.899902C13.6444 0.899902 17.1004 4.3559 17.1004 8.61419C17.1004 10.252 16.5891 11.7712 15.7176 13.0207L12.4434 9.74832C12.5457 9.40095 12.6004 9.03919 12.6004 8.67263V6.70899L9.45039 5.3999L8.49142 5.79843ZM16.642 15.6301C16.4296 15.8499 16.0634 15.8499 15.8437 15.6301L2.16206 1.96313C1.94966 1.74341 1.94233 1.3772 2.16206 1.16479C2.38911 0.945068 2.748 0.945068 2.96772 1.16479L16.642 14.8318C16.8618 15.0515 16.8618 15.4104 16.642 15.6301Z",
  fill: "#878793"
});

function SvgIconModerationCrossedFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModerationCrossedFilled);
export default __webpack_public_path__ + "static/media/icon-moderation-crossed-filled.5ea960e1.svg";
export { ForwardRef as ReactComponent };